<template>
  <a-layout id="components-layout-demo-custom-trigger">
    <!-- 左侧菜单栏 -->
    <a-layout-sider
      v-model="collapsed"
      :trigger="null"
      collapsible
      style="height: 100%"
    >
      <div v-if="!collapsed">
        <img
          src="../../../assets/images/logo-white.png"
          alt=""
          style="margin: 1em"
        />
      </div>
      <div class="logo" v-else>
        <div style="color: aliceblue">招采平台</div>
        <!-- <img src="../../../assets/images/logo(1).png" alt="" /> -->
      </div>
      <a-menu
        class="menu"
        theme="dark"
        mode="inline"
        :selected-keys="selectedKeys"
        :open-keys.sync="openKeys"
        @openChange="onOpenChange"
        :key="menuKey"
        :inline-collapsed="collapsed"
        style="font-weight: 700; font-family: Microsoft YaHei, Microsoft YaHei"
      >
        <template v-for="menuInfo in menuList">
          <template v-if="!menuInfo.meta.hideInMenu">
            <sub-menu
              v-if="hasChild(menuInfo)"
              :key="menuInfo.path"
              :sub-menu-info="menuInfo"
              :collapsed="collapsed"
              @MenuItemClick="MenuItemClick"
            />
            <a-menu-item
              v-else
              :key="menuItem(menuInfo).path"
              @click="MenuItemClick(menuItem(menuInfo).path)"
            >
              <a-icon
                :type="retIcon(menuInfo.meta.icon)"
                :style="{
                  fontSize: collapsed ? '23px' : '18px',
                  marginRight: '5px',
                }"
              />
              <span :title="menuItem(menuInfo).meta.title">
                {{ menuItem(menuInfo).meta.title }}
              </span>
            </a-menu-item>
          </template>
        </template>
      </a-menu>
    </a-layout-sider>
    <a-layout>
      <!-- 顶部栏 -->
      <a-layout-header class="layout-heade">
        <div class="tips">
          <a-icon
            class="trigger"
            :type="collapsed ? 'menu-unfold' : 'menu-fold'"
            @click="toggleCollapsed"
          />
          <a-icon class="refresh" type="redo" @click="refreshPage" />
          <!-- 面包屑 -->
          <!-- <breadcrumb></breadcrumb> -->
        </div>
        <!-- 用户信息 -->
        <div style="display: flex; align-items: center">
          <!-- <a-icon
            style="font-size: 17px"
            type="area-chart"
            @click="visualization"
          /> -->
          <info class="info" style="height: 100%"></info>
        </div>
      </a-layout-header>
      <!-- 内容区域 -->
      <a-layout-content class="layout-content">
        <cahcheView class="content" />
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import mixin from "./components/layout-sider/mixin";
import SubMenu from "./components/layout-sider/SubMenu.vue";
import cahcheView from "./components/cache-view";
// 面包屑
import breadcrumb from "./components/breadcrumb";
// 用户
import info from "./components/info";

export default {
  components: { SubMenu, cahcheView, breadcrumb, info },
  mixins: [mixin],
  data() {
    return {
      collapsed: false,
      selectedKeys: [],
      openKeys: [],
      menuKey: 0,
    };
  },
  computed: {
    ...mapGetters({
      menuList: "app/menuList",
    }),
    ...mapState({
      menu: (state) => state.item.menu,
    }),
  },
  watch: {
    openKeys(val, newVal) {
      this.openKeys = val;
      this.saveMenuState();
    },
    // 监听菜单
    // menu(newVal, oldVal) {
    //   // this.selectedKeys = ["/pages/commodityManagement/index"];
    // },
    $route(to, from) {
      this.selectedKeys = [to.path];
      console.log("路由已经从", from.path, "变化到", to.path);
    },
  },
  created() {
    this.loadMenuState();
  },
  methods: {
    // 页面刷新
    refreshPage() {
      window.location.reload();
    },
    retIcon(e) {
      return e;
    },
    // 是否内嵌
    toggleCollapsed() {
      this.collapsed = !this.collapsed;
      this.saveMenuState();
    },
    onOpenChange(openKeys) {
      // console.log(openKeys);
    },
    // 菜单点击
    MenuItemClick(path) {
      if (path) {
        this.$router.push(path);
        this.updateSelectedKeys(path);
      }
    },
    // 更新并保存选中菜单项
    updateSelectedKeys(path) {
      // this.selectedKeys = [path];
      this.saveMenuState();
    },
    saveMenuState() {
      localStorage.setItem(
        "menuState",
        JSON.stringify({
          collapsed: this.collapsed,
          selectedKeys: [this.$route.path],
          openKeys: this.openKeys,
        })
      );
    },
    loadMenuState() {
      const menuState = localStorage.getItem("menuState");
      if (menuState) {
        const state = JSON.parse(menuState);
        this.collapsed = state.collapsed;
        this.selectedKeys = state.selectedKeys;
        this.openKeys = state.openKeys;
      }
    },
    // 可视页跳转
    visualization() {
      this.$router.push("/");
    },
  },
};
</script>

<style lang="less" scoped>
#components-layout-demo-custom-trigger {
  height: 100%;
}

#components-layout-demo-custom-trigger .trigger {
  font-size: 17px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}
#components-layout-demo-custom-trigger .refresh {
  font-size: 17px;
  cursor: pointer;
  margin-right: 3rem;
  transform: rotate(270deg);
}

#components-layout-demo-custom-trigger .trigger:hover {
  // color: #1890ff;
  color: #0096d5;
}

#components-layout-demo-custom-trigger .logo {
  height: 4.5%;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    height: 80%;
  }
}
.menu {
  height: 92%;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari */
  }
  scrollbar-width: none; /* Firefox */
}
.layout-heade {
  background: #fff !important;
  padding: 0 !important;
  display: flex;
  justify-content: space-between;
}
.tips {
  height: 100%;
  display: flex;
  align-items: center;
}
.info {
  height: 100%;
}
.info:hover {
  background: rgba(0, 0, 0, 0.025);
  transition: 1s;
}
.layout-content {
  padding: 16px;
  overflow: auto;
}
.content {
  padding: 12px;
  border-radius: 6px;
  background: #ffffff;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari */
  }
}
/deep/.ant-menu.ant-menu-dark .ant-menu-item-selected {
  // background: #264461;
  background: #007bb5;
  // border-right: 6px solid #036beb;
  border-right: 6px solid #5bcfff;
  // transition: background-color 0.1s ease, border-left 0.2s ease;
  transition: none !important;
  margin-left: 10px;
  margin-right: 10px;
  width: 180px;
  padding-left: 38px !important;
}
/deep/.ant-menu-item,
.ant-menu-submenu-title {
  transition: none !important;
}
/deep/.ant-menu-dark {
  // background: #233643 !important; //背景色
  background: #0096d5 !important;
  color: #fff !important;
}
/deep/.ant-menu-dark .ant-menu-inline.ant-menu-sub {
  // background: #233643 !important;
  background: #0096d5 !important;
  box-shadow: none !important;
}
/deep/.ant-layout-sider {
  // background: #233643 !important;
  background: #0096d5 !important;
}
</style>